<template>
  <b-card>
    <div class="min-h-[80vh]">
      <div class="flex items-center justify-between">
        <div class="font-semibold text-2xl leading-none tracking-normal align-middle">
          AI Customer Service
        </div>
        <b-button
          variant="primary"
          :disabled="isLoadingCreate"
          @click="addAgent()"
        >
          <div>
            <b-icon
              v-if="isLoadingCreate"
              icon="arrow-clockwise"
              animation="spin"
            />
            <b-icon
              v-else
              class="mr-1"
              icon="plus"
              scale="1.3"
            />
            <span>Tambah AI Customer Service</span>
          </div>
        </b-button>
      </div>
      <b-overlay
        :show="isLoading"
        rounded="sm"
      >
        <div
          v-show="!agentList.length && !isLoading"
          class="mt-3 grid justify-center"
        >
          <b-img
            center
            class="mt-3 mb-2"
            src="https://storage.googleapis.com/komerce/assets/LP-Komchat/icon-ai-komchat-ai.svg"
            alt="AI Customer Service"
          />
          <div class="font-poppins font-normal text-black mb-1 leading-none tracking-normal text-center align-middle">
            Kamu belum memiliki AI Customer Service
          </div>
          <div class="font-poppins font-normal text-sm leading-none tracking-normal text-center align-middle">
            Yuk, buat AI Customer Service pertama kamu!
          </div>
        </div>
        <div class=" mt-2 p-1">
          <CardCsAi
            :data-agent="agentList"
            @refresh="getAgentList"
          />
        </div>
      </b-overlay>
    </div>
    <ModalCheckCsAi
      :product-list-empty="isProductEmpty"
      :whats-app-cs-ai-empty="isWhatsAppCsAiEmpty"
      :payment-was-set="isPaymentWasSet"
    />
    <ModalValidationAccessBroadcast
      :is-expired="isExpiredPackage"
      :context="'customer_service'"
    />
  </b-card>
</template>

<script>
import { mapState } from 'vuex'
import CardCsAi from './Ai/CardCsAi.vue'
import ModalCheckCsAi from './modal/ModalCheckCsAi.vue'
import { apiGetAgentList } from './Ai/service/api.agent.service'
import ModalValidationAccessBroadcast from './Broadcast/components/ModalValidationAccessBroadcast.vue'

export default {
  name: 'AiCustomerService',
  components: {
    CardCsAi,
    ModalCheckCsAi,
    ModalValidationAccessBroadcast,
  },

  data() {
    return {
      agentList: [],
      isLoading: false,
      isLoadingCreate: false,
      isWhatsAppCsAiEmpty: false,
      isProductEmpty: false,
      isPaymentWasSet: false,
    }
  },
  computed: {
    ...mapState('komchat', ['whatsAppList', 'productList', 'paymentInterface']),
    ...mapState('whatsapp', {
      dashboardWa: state => state.dashboard_wa || {},
    }),

    isExpiredPackage() {
      return this.dashboardWa.whatsapp_expired_at === 0
    },
    komchatLevelPackage() {
      return this.dashboardWa.subscription_plan_level
    },
  },
  async mounted() {
    this.checkExpiredPackage()
    this.getAgentList()
    // await this.checkAccess() // Ensure product list is loaded on mount
  },
  methods: {
    async checkAccess() {
      try {
        await this.$store.dispatch('komchat/getWhatsAppList')
        await this.$store.dispatch('komchat/getProductList')
        await this.$store.dispatch('komchat/getPaymentInterface')
      } catch (error) {
        this.$toast_error({ message: 'Gagal memuat data. Silakan coba lagi.' })
      }
    },
    async addAgent() {
      this.isLoadingCreate = true
      try {
        await this.checkAccess()
        const whatsAppCsAi = this.whatsAppList ? this.whatsAppList?.filter(item => item.type === 'komchat_ai') : []

        this.isProductEmpty = !this.productList?.length
        this.isWhatsAppCsAiEmpty = !whatsAppCsAi?.length
        this.isPaymentWasSet = !this.paymentInterface?.color

        if (this.isProductEmpty || this.isWhatsAppCsAiEmpty || this.isPaymentWasSet) {
          this.$bvModal.show('modal-check-before-create-cs-ai')
        } else {
          this.$router.push({ name: 'create-ai-customer-service' })
        }
      } catch (error) {
        this.$toast_error({ message: 'Gagal menambahkan agent' })
      } finally {
        this.isLoadingCreate = false
      }
    },
    async getAgentList() {
      this.isLoading = true
      try {
        const { data } = await apiGetAgentList()
        this.agentList = data?.data || []
      } catch (error) {
        this.$toast_error({ message: 'Gagal mengambil data CS AI' })
      } finally {
        this.isLoading = false
      }
    },
    async checkExpiredPackage() {
      try {
        await this.$store.dispatch('whatsapp/getUpdateDashboardWa')
        if (this.isExpiredPackage || this.komchatLevelPackage < 2) {
          this.$bvModal.show('modal-validation-access-broadcast')
        }
      } catch (error) {
        this.$toast_error({ message: 'Gagal memeriksa status paket' })
      }
    },
  },
}
</script>
